import React, { useState, useEffect } from 'react';



const Footer = () => {

    //
    const [year, setYear] =  useState('');
    
    //
    useEffect(() => {
       if(year === ''){
        var x = new Date();
        setYear(x.getFullYear());
       }else{
           console.log("Fecha cargada")
}
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);
    
    return (
        <div className="close">
           <p>Hecho por Render Playz<br/>Todos los derechos reservados <span>&copy;</span> {year}</p>
        </div>
    )

}

export default Footer;